import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { RoundButton } from "../../../ui/Button/Button";
import { CrossIcon } from "../../../ui/icons/CrossIcon";

type DealerOrderModalHeaderProps = {
  close: VoidFunction;
};

export const BuyNowModalHeader: FunctionComponent<
  DealerOrderModalHeaderProps
> = ({ close }) => {
  const { t } = useTranslation();
  return (
    <header className="flex items-center gap-2 md:gap-6 lg:gap-8 justify-between">
      <h2 className="text-xl font-semibold">
        {t("dealerOrderModal.orderPreview")}
      </h2>
      <RoundButton aria-label="closesOrderDialog" onClick={close}>
        <CrossIcon />
      </RoundButton>
    </header>
  );
};
